import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Typography, CircularProgress, Box } from "@mui/joy";
import { AuthLayout } from "../components/auth/AuthLayout";
import { CompleteProfileForm } from "../components/auth/CompleteProfileForm";
import { useAuthStore } from "../store/authStore";

export const CompleteProfilePage: React.FC = () => {
  const navigate = useNavigate();
  const { session, initialized, isOnboardingComplete } = useAuthStore();

  // Redirect if not authenticated
  useEffect(() => {
    if (initialized && !session) {
      navigate("/");
    }
  }, [initialized, session, navigate]);

  // Redirect if already onboarded
  useEffect(() => {
    if (initialized && session && isOnboardingComplete()) {
      navigate("/");
    }
  }, [initialized, session, isOnboardingComplete, navigate]);

  // Show loading while checking auth state
  if (!initialized) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "#FDF8F5",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <AuthLayout
      title="Complete your profile"
      subtitle="Tell us a bit about yourself"
    >
      <Typography
        level="body-sm"
        sx={{ mb: 3, color: "#6B6B6B", textAlign: "center" }}
      >
        Add your name and a photo so your travel buddies can recognize you
      </Typography>

      <CompleteProfileForm onSuccess={() => navigate("/")} />
    </AuthLayout>
  );
};
